import { WModalButton } from "@/components/button/WToolButton.tsx";
import { WModalForm } from "@/components/forms/WModalForm.tsx";
import { WModal } from "@/components/modal/WModal.tsx";
import { useStandardMutation } from "@/modules/api/useStandardMutation.ts";
import { ParamsTextField } from "@/modules/compute/ParamsTextField.tsx";
import { updateSshKeyMutation } from "@/modules/compute/sshKeysQuery.ts";
import { parametersByNameAtom } from "@/modules/compute/vmParametersQuery.ts";
import { useSuspenseQueryAtom } from "@/utils/query/useSuspenseQueryAtom.ts";
import { useLingui } from "@lingui/react/macro";
import type { SshKey, SshKeyUpdateBody } from "@warrenio/api-spec/spec.oats.gen";
import { useForm, type SubmitHandler } from "react-hook-form";

export interface SshKeysInputsInputs extends SshKeyUpdateBody {}

function UpdateSshKeyModalContent({ item }: { item: SshKey }) {
    //#region Hooks
    const { t } = useLingui();
    const params = useSuspenseQueryAtom(parametersByNameAtom);
    const mutation = useStandardMutation(updateSshKeyMutation);

    //#endregion

    const nameParams = params.get("name")!;

    const onSubmit: SubmitHandler<SshKeysInputsInputs> = async (inputs) => {
        const { name } = inputs;

        await mutation.mutateAsync({
            body: {
                name,
            },
            uuid: item.uuid,
        });
    };

    const form = useForm<SshKeysInputsInputs>({
        disabled: mutation.isPending,

        mode: "onBlur",
        reValidateMode: "onBlur",

        defaultValues: {
            name: item.name,
        },
    });

    return (
        <WModalForm form={form} onSubmit={onSubmit} title={t`Update SSH key`} label={t`Update`}>
            <ParamsTextField form={form} autoFocus wide field="name" params={nameParams} label={t`Name`} />
        </WModalForm>
    );
}

export function UpdateSshKeyModal({ item }: { item: SshKey }) {
    const { t } = useLingui();
    return (
        <WModal button={<WModalButton inTable label={t`Edit`} icon="jp-icon-edit" />}>
            <UpdateSshKeyModalContent item={item} />
        </WModal>
    );
}
